import type { User } from '../../types/context.types';

export function analyticsUserId(user: User | null): string | undefined {
  if (!user) return undefined;
  const u = user as User & { id?: string; loginId?: string };
  const raw = u.id ?? u.loginId;
  return raw != null && raw !== '' ? String(raw) : undefined;
}
